export default () => {
	document.documentElement.scrollTo({
		top: 0,
		left: 0,
		behavior: 'smooth',
	});
};
